// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1fZfb","upload":"Small_upload__39HBV","imageWrap":"Small_imageWrap__3Cu4K","removeBtn":"Small_removeBtn__3_4Mu"};